import { type ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

// Teach tailwind-merge about our custom font-size utilities defined via
// `@theme` in `src/styles/globals.css` (global ramp) and
// `src/styles/client-theme.css` (client portal ramp). Without this,
// twMerge treats e.g. `text-client-body-md` + `text-client-foreground` as
// conflicting `text-*` classes and strips one of them.
//
// Keep this list in sync with the `--text-*` and `--text-client-*` tokens
// in those files. If you add or rename a token there, mirror the change here.
const customFontSizeTokens = [
  // Existing global tokens (mirrored from globals.css @theme):
  'display-xl',
  'display-lg',
  'display-sm',
  'title-md',
  'label-md',
  'body-md',
  'body-sm',
  'meta-sm',
  // Client-portal tokens (mirrored from client-theme.css @theme).
  // Add or rename here whenever client-theme.css changes.
  'client-display-xl',
  'client-display-md',
  'client-display-sm',
  'client-heading',
  'client-body-lg',
  'client-body-md',
  'client-body-sm',
  'client-caption',
  'client-eyebrow',
  'client-eyebrow-md',
  'client-step-label',
  'client-micro',
  'client-title-md',
  'client-label-md',
  'client-meta-sm',
];

const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [{ text: customFontSizeTokens }],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
